<template>
  <CModal title="My Ideas" :show.sync="detailModal" color="success" centered>
    <template v-slot:body-wrapper>
      <div
        class="modal-body overflow-auto"
        style="max-height: calc(100vh - 12.5rem)"
      >
        <div class="form-row mb-3">
          <div class="col-9">
            <div class="rounded position-relative">
              <input
                class="form-control form-control-sm pl-5"
                type="search"
                placeholder="Search..."
                aria-label="Search"
                v-model="textSearch"
                @keyup.enter="loadMyIdeas(textSearch, fromSolution)"
              />
              <button
                style="position: absolute; left: 0; bottom: 0"
                class="btn bg-transparent px-2 py-0 position-absolute top-50 start-0 translate-middle-y"
                type="button"
                @click="loadMyIdeas(textSearch, fromSolution)"
              >
                <i class="fas fa-search"> </i>
              </button>
            </div>
          </div>
          <div class="col-3">
            <div class="form-row align-items-center">
              <div class="col-auto">
                <CSwitch
                  :checked.sync="fromSolution"
                  shape="pill"
                  variant="opposite"
                  size="sm"
                  color="info"
                  @update:checked="loadMyIdeas(textSearch, fromSolution)"
                />
              </div>
              <div class="col-auto">
                <span class="mb-2">Solution</span>
              </div>
            </div>
          </div>
        </div>
        <CListGroup v-if="ideas && ideas.length">
          <CListGroupItem
            v-for="(item, i) in ideas"
            :key="`item-${i}`"
            component="a"
            href="javascript:"
            class="p-1"
            :class="{ active: selected && item.Id == selected.Id }"
            @click="selected = selected && item.Id == selected.Id ? null : item"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">
                <i class="fas fa-lightbulb"></i>
                {{ item.Title }}
              </h5>
              <small>{{
                $moment(item.CreatedAt).format("DD/MM/YYYY hh:mm")
              }}</small>
            </div>
            <p class="mb-1 overflow-hidden" style="max-height: 4rem">
              {{ item.Description }}
            </p>
            <div>
              <small>
                <strong>
                  <i class="fas fa-globe mr-2"></i>
                  {{ item.Area.Name }}
                </strong>
                {{ item.IsAnonymous ? "(Anonymous)" : "" }}
              </small>
            </div>
          </CListGroupItem>
        </CListGroup>
        <div class="text-center text-danger" v-else>
          <strong>There is no idea!!!</strong>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <CButton
        v-if="selected"
        class="btn btn-success btn-sm"
        @click="chooseIdea"
      >
        <i class="fas fa-copy"></i>
        Copy
      </CButton>
      <CButton v-else class="btn btn-secondary btn-sm" disabled>
        <i class="fas fa-copy"></i>
        Copy
      </CButton>
    </template>
  </CModal>
</template>

<script>
export default {
  props: ["showing"],
  data() {
    return {
      detailModal: false,
      ideas: [],
      textSearch: null,
      fromSolution: false,
      selected: null,
    };
  },
  mounted() {
    this.loadMyIdeas(this.textSearch, this.fromSolution);
  },
  watch: {
    showing(val) {
      this.detailModal = val;
    },
    detailModal(val) {
      this.$emit("update:showing", val);
    },
  },
  methods: {
    chooseIdea() {
      if (this.selected) {
        this.$emit("copy", this.selected);
        this.detailModal = false;
      }
    },

    async loadMyIdeas(textSearch, fromSolution) {
      this.selected = null;
      let result = [];
      let filters = [];
      textSearch &&
        filters.push(
          `(contains(Title, '${textSearch}') or contains(Description, '${textSearch}'))`
        );
      if (fromSolution) {
        filters.push(`SipIdeaOfChallenges/any() eq true`);
      } else {
        filters.push(`SipIdeaOfChallenges/any() eq false`);
      }
      let resp = await this.$http.get(`odata/SipIdea`, {
        params: {
          isMine: true,
          $select: `Id,Title,Description,CreatedAt,IsAnonymous,AttachedFiles`,
          $expand: `Area($select=Name)`,
          $filter: filters.join(` and `),
        },
      });
      if (resp && resp.status == 200) {
        result =
          resp.data.value && resp.data.value.length ? resp.data.value : [];
      }

      this.ideas = result;
    },
  },
};
</script>